module.exports = __webpack_public_path__ + "img/filter-close.6451333a.svg";